import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import './index.css';
import clsx from 'classnames';
import { Loading } from 'components';
import NewsItem from '../components/NewsItem';
import QueueAnim from 'rc-queue-anim';
import { useNewsDetail, useNewsList, usePageTitle } from '../../../hooks';
import TweenOne from 'rc-tween-one';

const NewsDetail = () => {
  // 从路由参数中获取新闻 ID
  const { id } = useParams();
  const { data: listData, loading: listLoading } = useNewsList(
    { pageNo: 1, pageSize: 9 },
    { immediate: true },
  );
  const relatedList = listData?.list
    ?.filter((item) => item.id !== id)
    ?.slice(0, 4);

  const { data, loading, refresh } = useNewsDetail(id);

  useEffect(() => {
    refresh();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  // 设置页面标题 - 使用新闻标题
  usePageTitle(data?.title || '新闻详情');
  return (
    <div
      className={clsx('news-detail-top')}
      style={{ minHeight: window.innerHeight }}
    >
      {/* 顶部Banner */}
      <TweenOne
        className={clsx('news-banner')}
        animation={{ y: 30, opacity: 0, type: 'from' }}
      >
        新闻详情
      </TweenOne>
      {!loading && !listLoading ? (
        <>
          {/* 新闻内容 */}
          <QueueAnim
            className={clsx('news-detail-content')}
            type={['bottom', 'top']}
          >
            <div
              className={clsx('news-detail-content-title')}
              key='news-detail-content-title'
            >
              {data?.title}
            </div>
            <div
              className={clsx('news-detail-content-time')}
              key='news-detail-content-time'
            >
              {data?.add_time?.slice(0, 10)} &ensp; 浏览量：{data?.count}
            </div>
            <div
              className={clsx('news-detail-content-desc')}
              dangerouslySetInnerHTML={{ __html: data?.content }}
              key='news-detail-content-desc'
            />
          </QueueAnim>
          {/* 相关推荐 */}
          <div className={clsx('news-detail-related')}>
            <div className={clsx('news-detail-related-title')}>相关推荐</div>
            <div className={clsx('news-detail-related-list')}>
              {relatedList?.map((v, index) => {
                return <NewsItem v={v} key={index} />;
              })}
            </div>
          </div>
        </>
      ) : (
        <Loading />
      )}
    </div>
  );
};

export default NewsDetail;
